module.exports = __webpack_public_path__ + "img/hgz.2c19c418.png";